import type { ReactElement } from 'react';
import useMedia from '../../../../shared/useMedia';

type ResponsiveWrapperProps = {
  smallScreenComponent: ReactElement;
  largeScreenComponent: ReactElement;
};

export const ResponsiveWrapper = ({
  smallScreenComponent,
  largeScreenComponent,
}: ResponsiveWrapperProps): ReactElement => {
  const { isLargeScreen } = useMedia();

  return !isLargeScreen ? smallScreenComponent : largeScreenComponent;
};
